import React from "react";
import Markdown from "react-markdown";

import { ASSISTANT_MARKDOWN_ALLOWED_ELEMENTS } from "./constants";
import { AssistantMarkdownContent } from "./styles";
import { IAssistantMarkdownProps } from "./types";

const AssistantMarkdown: React.FC<IAssistantMarkdownProps> = ({ children }) => (
  <AssistantMarkdownContent>
    <Markdown skipHtml allowedElements={ASSISTANT_MARKDOWN_ALLOWED_ELEMENTS}>
      {children}
    </Markdown>
  </AssistantMarkdownContent>
);

export default AssistantMarkdown;
